<template>
  <section>
    <article class="panel">
      <div class="panel-heading has-text-centered">
        {{ label }}
      </div>
      <div class="panel-block">
        <b-table :data="interno.items" class="table" striped hoverable>
          <template >
            <b-table-column v-slot="props" field="" label="">
              <b-button
                type="is-danger"
                native-type="button"
                icon-left="delete"
                class="button-delete"
                @click="deleteItem(props.row)"
              >
              </b-button>
            </b-table-column>
            <b-table-column v-slot="props" field="id" label="Id" class="id-column">
                <b-input
                  v-model="props.row.id"
                  @blur="getByProp(props.row,'id')"
                  @keyup="$emit('update:id', inputid)"
                  icon="magnify"                  
                ></b-input>
            </b-table-column>
            <b-table-column v-slot="props" field="nome" label="Nome">
              <b-autocomplete
                :data="data"
                v-model="props.row.nome"
                ref="autocomplete"
                field="nome"
                icon="magnify"
                :loading="isFetching"
                @typing="getAsyncData"
                @select="selectItem(props.row, $event)"
              >
                <template #empty v-if="isFetching">
                  Nenhum {{ label }} encontrado
                </template>
                <template #default="props">
                  <div>
                    <div class="">
                      <div class="tag">{{ props.option.id }}</div>
                      {{ props.option.nome }}
                    </div>
                  </div>
                  <slot
                    v-if="hasDefaultSlot"
                    :option="props.option"
                    :index="props.index"
                  />
                </template>
              </b-autocomplete>
            </b-table-column>
          </template>
        </b-table>
        <div class="buttons has-text-centered">
          <b-button
            type="is-success"
            native-type="button"
            icon-left="plus"
            class="center"
            @click="addItem()"
          >
            Incluir
          </b-button>
        </div>
      </div>
    </article>
  </section>
</template>

<style scoped>
.button-delete {
  max-height: 1.5rem;
}

.id-column {
  max-width: 60px;
}

.table {
  width: 100%;
  display: block;
  /* max-height: 30vh;
  overflow-y: auto;   */
}

.panel-block {
  display: block;
}

.center {
  margin: 0 auto;
}
</style>

<script>
    import http from '@/http'
import debounce from "lodash/debounce";
import { hasSlot } from "@/utils/vueCompat";

export default {
  props: {
    items: [],
    label: null,
    tabela: null
  },
  data() {
    return {
      data: [],
      inputid: this.id,
      isFetching: false,
      interno: {
        items: [],
      },
    };
  },
  mounted(){
    this.interno.items = this.items;
  },  
  watch: {
    items() {
      this.interno.items = this.items;
    },
  },
  computed: {
    hasDefaultSlot() {
      return hasSlot(this);
    },
  },
  methods: {
    getAsyncData: debounce(function (name) {
      if (!name.length) {
        this.data = [];
        return;
      }
      this.isFetching = true;
      http
        .get(`/api/Search/${this.tabela}?nome=${name}&_=${new Date().getTime()}`)
        .then(({ data }) => {
          this.data = [];
          data.forEach((item) => this.data.push(item));
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    }, 500),
    addItem() {
      this.interno.items.push({
        id: null,
        nome: null,
        changed: true,
        show: true,
      });
      setTimeout(() => {
        this.$refs.autocomplete.focus();
      }, 100);
    },
    deleteItem(item) {
      this.interno.items = this.interno.items.filter((i) => i.id !== item.id);
      this.change();
    },
    selectItem(item, option) {
      item.id = option.id;
      item.nome = option.nome;
      item.changed = true;
      this.change();
    },
    change() {
      //Filtrando por registro unicos
      this.interno.items = this.interno.items?.map(i => i.id)?.filter((i,idx,all) => all.indexOf(i) === idx)?.map(i => {
        return {
          id: i,
          nome: this.interno.items?.find(x => x.id === i)?.nome
        }
      });
      const result = this.interno.items;
      this.$emit("update:items", result);
    },
    getByProp(item, propName) {
      this.isFetching = true;
      http
        .get(`/api/Search/${this.tabela}Id?${propName}=${item.id}`)
        .then(({ data }) => {
          item.id = data.id;
          item.nome = data.nome;
          this.change();
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
  },
};
</script>
